import type { AgentBetaRouter } from "replo-publisher/src/trpc/routers/agentBeta";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: agentBetaRouter,
  client: agentBetaClient,
  utils: agentBetaUtils,
  options: agentBetaOptions,
} = createTrpcRouterConfig<AgentBetaRouter>({
  path: "agentBeta",
  queryClient: getNamespacedQueryClient("agentBeta"),
});

export { agentBetaClient, agentBetaRouter, agentBetaUtils, agentBetaOptions };
